import * as React from 'react';
import {
  Glyphicon,
  LineSeparator,
  TakeTourItem,
  TakeTourLink,
  TakeTourContainer
} from './TakeTour.style';
import PropTypes from 'prop-types';
import TourIcon from 'img/icons/tour-icon.svg';

/**
 * Side Menu List of Links
 *
 * @param {Object} props All the properties passed to the React Component.
 * @param {function} props.startMultiPageTour Starts the multipage tour
 * @param {function} props.toggleMenu Used here mostly for timing purposes.
 * @returns {StatelessComponent} Stateless functional React component.
 */
export const TakeTourComponent = ({ startMultiPageTour }, { t }) => {
  const title = t('Take a Tour');
  return (
    <TakeTourContainer>
      <LineSeparator />
      <div>
        <TakeTourItem>
          <TakeTourLink
            to="#"
            onClick={() => startMultiPageTour('take-tour-link')}
          >
            <Glyphicon src={TourIcon} alt={title} title={title} />
            {title}
          </TakeTourLink>
        </TakeTourItem>
      </div>
    </TakeTourContainer>
  );
};

TakeTourComponent.propTypes = {
  startMultiPageTour: PropTypes.func.isRequired
};

TakeTourComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default TakeTourComponent;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/TakeTour/TakeTourComponent.js